import { render, staticRenderFns } from "./BarcodeModal.vue?vue&type=template&id=dc5b5d84&scoped=true&"
import script from "./BarcodeModal.vue?vue&type=script&lang=js&"
export * from "./BarcodeModal.vue?vue&type=script&lang=js&"
import style0 from "./BarcodeModal.vue?vue&type=style&index=0&id=dc5b5d84&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dc5b5d84",
  null
  
)

export default component.exports